import { Box, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FC } from "react";
import theme from "../../../theme";

const useStyles = makeStyles((theme) => ({
    badge: {
        borderRadius: 32,
        padding: '5.5px 8px'
    }
}))

const Tag: FC<{
    title: string;
    color?: string;
}> = ({ title, color }) => {
    const styles = useStyles();

    return (
        <Box className={styles.badge} sx={{ backgroundColor: color ?? theme.colors.neutral['100'] }}>
            <Typography variant="b3-semibold" color={theme.colors.neutral['700']} component="h1">{title}</Typography>
        </Box>
    )
}

export default Tag;
